

export default function Image({ style, className, name, id, alt, local }) {
    const url = (local ? window.location.origin.toString() + '/icons/' : process.env.REACT_APP_STORAGE_URL) + name
    // const url = "http://storage.test.courtens.fr/" + name

    return (
        <img id={id} style={style} className={className} src={url} alt={alt} />
    )
}